var React = require('react');

function Favorites (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.233 8.55L12 2 8.767 8.55 1.538 9.6l5.231 5.1-1.235 7.2L12 18.5l6.466 3.4-1.235-7.2 5.23-5.1-7.228-1.05zM12 4.258l2.569 5.206 5.743.835-4.156 4.052.982 5.72-5.138-2.7-5.139 2.7.983-5.72-4.157-4.052 5.744-.835L12 4.258z"}));
}

Favorites.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Favorites;

Favorites.default = Favorites;
